function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { client, larkiApi } from '../../utilities/api';
import { captureError } from '../../utilities/error';
import { getUserMembership } from '../../utilities/user';
import { alertConstants, profileConstants } from '../constants';
export var startProductTrial = function(param) {
    var productId = param.productId;
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(dispatch) {
            var data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        dispatch({
                            type: profileConstants.FETCH_USER_DETAILS_LOADING
                        });
                        return [
                            4,
                            larkiApi.post('/user/products/trial', {
                                productId: productId
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        dispatch({
                            type: profileConstants.FETCH_USER_DETAILS_SUCCESS,
                            userProfile: data
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        dispatch({
                            type: profileConstants.FETCH_USER_DETAILS_FAILURE
                        });
                        dispatch({
                            type: alertConstants.ALERT_ERROR,
                            payload: {
                                message: error.response.data.message
                            }
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var updateMapType = function(mapTypeId) {
    var skipDispatch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(dispatch) {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            larkiApi.put('/user/map-type', {
                                map_type: mapTypeId
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (!skipDispatch) {
                            dispatch({
                                type: profileConstants.UPDATE_MAP_TYPE,
                                payload: mapTypeId
                            });
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if (!skipDispatch) {
                            dispatch({
                                type: alertConstants.ALERT_ERROR,
                                payload: {
                                    message: error.response.data.message
                                }
                            });
                        }
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var getMembershipPrices = function() {
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(dispatch) {
            var data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        dispatch({
                            type: profileConstants.GET_MEMBERSHIP_PRICES_LOADING
                        });
                        return [
                            4,
                            larkiApi.get('/user/prices')
                        ];
                    case 1:
                        data = _state.sent().data;
                        dispatch({
                            type: profileConstants.GET_MEMBERSHIP_PRICES_SUCCESS,
                            payload: data
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        dispatch({
                            type: alertConstants.ALERT_ERROR,
                            payload: {
                                message: error.response.data.message
                            }
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var getMembershipReceipt = function(paymentIntentId) {
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(dispatch) {
            var data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        dispatch({
                            type: profileConstants.GET_MEMBERSHIP_RECEIPT
                        });
                        return [
                            4,
                            client.getMembershipReceipt(paymentIntentId)
                        ];
                    case 1:
                        data = _state.sent().data;
                        dispatch({
                            type: profileConstants.GET_MEMBERSHIP_RECEIPT_SUCCESS,
                            payload: data
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        dispatch({
                            type: alertConstants.ALERT_ERROR,
                            payload: {
                                message: error.response.data.message
                            }
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var refreshCustomer = function() {
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(dispatch) {
            var data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            client.refreshCustomer()
                        ];
                    case 1:
                        data = _state.sent().data;
                        dispatch({
                            type: profileConstants.REFRESH_CUSTOMER_SUCCESS,
                            payload: data
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        captureError(error);
                        dispatch({
                            type: alertConstants.ALERT_ERROR,
                            payload: {
                                message: error.response ? error.response.data.message : error.message
                            }
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var getMembershipDetails = function() {
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(dispatch) {
            var data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        dispatch({
                            type: profileConstants.GET_MEMBERSHIP_DETAILS,
                            payload: data
                        }); // Loader = true
                        return [
                            4,
                            client.getUserMembership()
                        ];
                    case 1:
                        data = _state.sent().data;
                        dispatch({
                            type: profileConstants.GET_MEMBERSHIP_DETAILS_SUCCESS,
                            payload: data
                        }); // Loader = false
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        dispatch({
                            type: alertConstants.ALERT_ERROR,
                            payload: {
                                message: error.response.data.message
                            }
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * Subscribes a user to a trial/recurring membership.
 * When subscribing to a recurring membership **without** a trial, returned object has payment_intent_secret
 *  which is used in stripe.confirmCardPayment to finalize creation of the membership.
 *
 * @param {object} user with customer.memberships field
 * @param {string} priceId in Stripe
 * @param {string} [paymentMethodId] in Stripe - required if isTrial is false
 * @param {boolean} isTrial Start a trial?
 * @returns {*} Membership object
 */ export var subscribe = function(param) {
    var user = param.user, priceId = param.priceId, paymentMethodId = param.paymentMethodId, isTrial = param.isTrial;
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(dispatch) {
            var existingMembership, newMembership, data, data1, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            7,
                            8
                        ]);
                        if (isTrial && user.has_used_trial) {
                            throw Error('requesting new trial but user has trialed before');
                        }
                        if (!isTrial && !paymentMethodId) {
                            throw Error('requesting recurring membership but payment method ID not provided');
                        }
                        dispatch({
                            type: profileConstants.UPSERT_USER_MEMBERSHIP
                        });
                        existingMembership = getUserMembership(user);
                        if (!!existingMembership) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            client.createMembership(priceId, paymentMethodId, isTrial // possible combinations (all valid): !is_trial !has_used_trial, !is_trial has_used_trial, is_trial !has_used_trial
                            )
                        ];
                    case 1:
                        data = _state.sent().data;
                        // newMembership = { id, name, status, ... payment_intent_secret?: ... }
                        newMembership = data;
                        if (!(newMembership === null || newMembership === void 0 ? void 0 : newMembership.payment_intent_secret) && !isTrial) {
                            throw Error('requesting recurring membership but createMembership did not return payment intent secret');
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        if (isTrial) {
                            throw Error('requesting new trial but user has existing membership');
                        }
                        return [
                            4,
                            client.updateMembership(priceId, paymentMethodId)
                        ];
                    case 3:
                        data1 = _state.sent().data;
                        // newMembership = { id, name, status, ... }
                        newMembership = data1;
                        _state.label = 4;
                    case 4:
                        if ((newMembership === null || newMembership === void 0 ? void 0 : newMembership.payment_intent_secret) && isTrial) {
                            throw Error('requesting new trial but create/updateMembership returned payment intent secret');
                        }
                        return [
                            4,
                            dispatch(refreshCustomer())
                        ];
                    case 5:
                        _state.sent();
                        if (isTrial) {
                            dispatch(setHasUsedTrial(true));
                        }
                        dispatch({
                            type: profileConstants.UPSERT_USER_MEMBERSHIP_SUCCESS,
                            payload: {
                                membership: newMembership
                            }
                        });
                        return [
                            2,
                            newMembership
                        ];
                    case 6:
                        error = _state.sent();
                        captureError(error);
                        dispatch({
                            type: alertConstants.ALERT_ERROR,
                            payload: {
                                message: error.response ? error.response.data.message // Axios error
                                 : error.request ? error.request.data.message // Axios error
                                 : error.message
                            }
                        });
                        return [
                            3,
                            8
                        ];
                    case 7:
                        // we need to set loading to false even if things fail or return early
                        dispatch({
                            type: profileConstants.UPSERT_USER_MEMBERSHIP_DONE
                        });
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var setHasUsedTrial = function(status) {
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(dispatch) {
            return _ts_generator(this, function(_state) {
                try {
                    dispatch({
                        type: profileConstants.SET_HAS_USED_TRIAL,
                        payload: status
                    });
                } catch (error) {
                    dispatch({
                        type: alertConstants.ALERT_ERROR,
                        payload: {
                            message: error.response.data.message
                        }
                    });
                }
                return [
                    2
                ];
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
